export const NA = "Sin especificar";

export const isEmpty = (v) => v === null || v === undefined || String(v).trim() === "";
export const orNA = (v) => (isEmpty(v) ? NA : String(v));

const usd = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const CURRENCIES = ["USD", "MXN"];
export const fmtMoney = (cents, currency = "USD") => (cents == null ? NA : `${currency || "USD"} ${usd.format(cents / 100)}`);

export const equivalent = (cents, currency, rate) => {
  const r = Number(rate);
  if (cents == null || !r || r <= 0) return null;
  return currency === "MXN" ? fmtMoney(Math.round(cents / r), "USD") : fmtMoney(Math.round(cents * r), "MXN");
};

export const fmtCredits = (v) => {
  if (isEmpty(v)) return NA;
  const s = String(v).trim();
  return /^\d+(\.\d{1,2})?$/.test(s) ? `USD ${usd.format(Number(s))}` : s;
};

export const fmtDate = (s) => {
  if (isEmpty(s)) return NA;
  const d = new Date(`${s}T00:00:00`);
  if (isNaN(d)) return NA;
  return d.toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" }) : NA;

export const amountToCents = (v) => {
  const s = String(v ?? "").trim();
  if (!/^\d{1,7}(\.\d{1,2})?$/.test(s)) return null;
  const c = Math.round(Number(s) * 100);
  return c > 0 ? c : null;
};

export const STATUS = {
  borrador: { label: "Borrador", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  pendiente: { label: "Pendiente", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  pagado: { label: "Pagado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  fallido: { label: "Fallido", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  cancelado: { label: "Cancelado", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  vencido: { label: "Vencido", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  reembolsado: { label: "Reembolsado", cls: "bg-violet-50 text-violet-700 border-violet-200" },
};

export const LINK_STATUS = { borrador: "Sin enlace (borrador)", activo: "Activo", cancelado: "Cancelado", vencido: "Vencido" };
export const PAYMENT_STATUS = { sin_iniciar: "Sin iniciar", pendiente: "Pendiente", pagado: "Pagado", fallido: "Fallido", reembolsado: "Reembolsado" };
export const MODE = { test: "Prueba", live: "Producción" };

export const payLink = (token) => `${process.env.REACT_APP_PUBLIC_LINK_URL}/pago/${token}`;
export const chargeLink = (c) => c.short_url || payLink(c.token);

export const waPhone = (p) => {
  const d = String(p || "").replace(/\D/g, "");
  if (!d) return "";
  return d.length === 10 ? `52${d}` : d;
};

export const WA_DEFAULT = {
  es: "Hola {nombre}, aquí está tu enlace seguro para completar el pago de tu reservación en {hotel}: {enlace}",
  en: "Hello {nombre}, here is your secure link to complete your reservation payment at {hotel}: {enlace}",
};

export const whatsappUrl = (c, hotel) => {
  const lang = c.language === "en" ? "en" : "es";
  const tpl = (hotel && hotel[`whatsapp_${lang}`]) || WA_DEFAULT[lang];
  const text = tpl.replaceAll("{nombre}", c.guest_name || "").replaceAll("{hotel}", hotel?.display_name || "")
    .replaceAll("{enlace}", chargeLink(c)).replace(/\s+([,:.])/g, "$1").replace(/ {2,}/g, " ");
  return `https://wa.me/${waPhone(c.phone)}?text=${encodeURIComponent(text)}`;
};

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}

export const DEMO_PREVIEW = {
  guest_name: null, room: null, adults: 2, minors: 0, infants: 0, check_in: null, check_out: null,
  resort_credits: null, transportation: null, additional_services: null,
  amount_cents: 199714, currency: "USD", processor_name: "Stripe",
};

export const chargeToTemplate = (c, processorName) => ({
  guest_name: c.guest_name, property_name: c.property_name, room: c.room, adults: c.adults, minors: c.minors, infants: c.infants,
  check_in: c.check_in, check_out: c.check_out, resort_credits: c.resort_credits,
  transportation: c.transportation, additional_services: c.additional_services,
  amount_cents: c.amount_cents ?? amountToCents(c.amount), currency: c.currency || "USD",
  processor_name: processorName ?? c.processor_name,
  total_cents: c.total_cents, initial_cents: c.initial_cents, balance_cents: c.balance_cents, exchange_rate: c.exchange_rate,
});
